import Roistat from './lib/Roistat'

export { default as Constants } from './lib/Constants'
export const roistat = new Roistat()
